<template>
<div height="100%" style="min-height:100%; padding: 2px;">
  <v-toolbar   dense>
    <v-toolbar-title>{{sendTitle}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="close">mdi-close</v-icon>
  </v-toolbar>
  <v-card height="100%" style="min-height:100%; padding: 0px;">
    <v-card-text>
      <v-divider />
      <v-container fluid align-start>
        <v-radio-group v-model="category" row class="justify-center">
          <v-radio label="Send to Users" value="individual"></v-radio>
          <v-radio label="Send to Group" value="group"></v-radio>
        </v-radio-group>
        <v-select v-model="target" :items="targets" label="To" multiple item-text="name" item-value="id"/>
        <v-select v-model="curMsg.priority" :items="pri" label="Priority" />
        <v-text-field v-model="curMsg.title" label="Title" outlined illed shaped/>
        <v-text-field v-model="curMsg.body" label="Message" outlined f />
        <v-textarea v-model="curMsg.msgDetails" label="Details" auto-grow outlined />
        <v-switch v-model="urlSwitch" :label="`Add URL`"></v-switch>
        <v-text-field v-model="curMsg.URL" v-if="urlSwitch" label="URL" />
        <v-text-field v-model="curMsg.URLLabel" v-if="urlSwitch" label="URL Label" outlined />
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-col class="text-right">
        <v-btn
          :disabled="target.length == 0 || curMsg.title == null || curMsg.body == null || curMsg.title == '' || curMsg.body == ''"
          v-on:click="sendMSG"
          color="primary"
          dark
          class="mb-2 ent-button"
          bottom
          left
          x-large
        >Send</v-btn>
      </v-col>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import { sync } from "vuex-pathify"
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  props: {
    msg: {
      type: Object,
      required: false,
      default: {'type': 'new', 'item': {
        title : null,
        desc : null,
        msgDetails : null
      }}
    }
  },
  components: {
  },
  data: () => ({
    curMsg: {},
    urlSwitch: false,
    category: "individual",
    contactData: [],
    groupData: [],
    groupDisplay: [],
    userDisplay: [],
    targets: [],
    pri: ["low", "medium", "high"],
    target: [],
    sendTitle: 'Send a Message'
  }),
  computed: {
    origLoggedinUser: sync('login/origLoggedinUser')
  },
  watch: {
    category: {
      immediate: true,
      handler (val) {
        if (val === "group") {
          this.targets = this.groupDisplay
        } else {
          this.targets = this.userDisplay
        }
      }
    },
    target (val) {
      // console.log(val)
    }
  },
  methods: {
    async fetchData() {
      let tempContacts = await axiosInstances.loginServer.get(
        "/dt/v1/users?org=" + this.origLoggedinUser.org
      );
      let tempGroups = await axiosInstances.apiServer.get("dt/v1/set_groups");
      this.contactData = tempContacts.data;
      this.groupData = tempGroups.data;
      // Process the data for display in the select menu
      for (let i = 0; i < this.contactData.length; i++) {
        this.userDisplay.push(
          {name: this.contactData[i].firstname + " " + this.contactData[i].lastname, id: this.contactData[i]._id}
        );
      }
      for (let i = 0; i < this.groupData.length; i++) {
        this.groupDisplay.push({name: this.groupData[i].name, id: this.groupData[i]._id})
      }
      this.targets = this.userDisplay
    },
    async sendMSG() {
      // {title: test 2, body: second test sep 28, type: individual, recipient: [58b2365cbfc2865d761d43ae], priority: high}
      let record = {};
      record["recipient"] = this.target;
      record["priority"] = this.curMsg.priority;
			record['domain'] = 'cortex';
      record["title"] = this.curMsg.title;
      record["body"] = this.curMsg.body;
      record["expanded"] = this.curMsg.msgDetails;
      if (this.category === "individual") record["type"] = "individual"
      else record["type"] = "group";
      if (this.msgURL !== null) record["extURL"] = this.curMsg.URL;
      if (this.msgURLLabel !== null) record["extURLText"] = this.curMsg.URLLabel;
      await axiosInstances.apiServer.post("dt/v1/temp_notifications", record);
      console.log('sent msg: ', record)
      this.$emit('update:closeSendWidget', {'op' : 'send'})
    },
    close () {
      this.$emit('update:closeSendWidget', {'op': 'close'})
    }
  },
  async mounted() {
    await this.fetchData()
    this.curMsg = Object.assign({},this.msg.item)
    this.category = 'individual'
    if (this.msg && this.msg.op != 'new') {
      this.curMsg.msgDetails = 'Previous Message: ' + this.curMsg.body +'\n'+ (this.curMsg.msgDetails || '')
      this.curMsg.body = ''
      this.curMsg.title = 'Re: ' + this.curMsg.title
      if (this.msg.op == 'reply') {
        this.sendTitle = 'Reply'
        this.category = 'individual'
        this.target = [this.curMsg.creator]
      } else if (this.msg.op == 'replyAll') {
        this.sendTitle = 'Reply to All'
        this.category = this.curMsg.type
        this.target = this.curMsg.typename
      } else if (this.msg.op == 'forward') {
        this.sendTitle = 'Forward'
        this.curMsg.title = 'Fw: ' + this.curMsg.title
      } else {
        // delete
      }
    } else {
      console.log(this.msg)
    }
    if (this.curMsg.priority == undefined) this.curMsg.priority = 'low'
  },
  beforeDestroy() {}
};
</script>

